module.exports = {

  # Although: (1) We don't have to do so here
  #           (2) This has nothing to do with promises
  #           (3) The resolved object is superfluous
  # Template loading has nothing to do with scope or functional logic - simply something
  # that has to happen for the view to render correctly. So better do it in the resolve
  # than in the controller. A sort of saying "This has to happen first".
  loadTemplates: ( $templateCache ) ->
    $templateCache.put('source-info-header', require('./Tabs/source-info.header.html'))
    $templateCache.put('source-info-tab', require('./Tabs/source-info.tab.html'))

    $templateCache.put('technology-header', require('./Tabs/technology.header.html'))
    $templateCache.put('technology-tab', require('./Tabs/technology.tab.html'))

    $templateCache.put('snapshot-header', require('./Tabs/snapshot.header.html'))
    $templateCache.put('snapshot-tab', require('./Tabs/snapshot.tab.html'))

    $templateCache.put('results-header', require('./Tabs/results.header.html'))
    $templateCache.put('results-tab', require('./Tabs/results.tab.html'))

}
